import { j as t } from "../../../../jsx-runtime.BREq8dyb.js";
import { faInfoCircle as n, faCircleExclamation as d } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as g } from "@fortawesome/react-fontawesome";
import { styled as f, Alert as u } from "@mui/joy";
import { memo as E } from "react";
import { useDataset as A } from "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import "../../contexts/FileContext/FileContext.js";
import "../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../contexts/NavigatorContext/NavigatorContext.js";
import "../../contexts/OptionsContext/OptionsContext.js";
import "../../contexts/SchemaContext/SchemaContext.js";
import "../../contexts/TypificationContext/TypificationContext.js";
import "../../contexts/WorkerContext/WorkerContext.js";
const S = "Loading…", h = void 0, x = "Please wait for the encryption and provisioning to complete.", M = "The provisioning has failed. Please check the error details below.", y = "The encryption and provisioning has completed successfully. This dialog can be now closed.", R = f(u)(({
  theme: e
}) => ({
  "& .MuiAlert-icon": {
    alignItems: "flex-start",
    display: "flex",
    fontSize: "1rem",
    justifyContent: "center",
    lineHeight: "1rem",
    marginRight: e.spacing(0.75),
    padding: e.spacing(0.5, 0)
  },
  "& .MuiAlert-message": {
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    padding: e.spacing(0),
    whiteSpace: "pre-wrap"
  },
  borderRadius: 0,
  flex: 1,
  padding: e.spacing(0.5, 1)
})), G = E(({
  analyzingMessage: e = S,
  defaultMessage: s = h,
  uploadingMessage: a = x,
  uploadErrorMessage: l = M,
  uploadResultMessage: p = y
}) => {
  const {
    validationError: o,
    analyzing: i,
    uploading: c,
    uploadError: r,
    uploadResult: m
  } = A();
  return /* @__PURE__ */ t.jsx(R, { color: i ? "neutral" : o || r ? "danger" : "neutral", startDecorator: /* @__PURE__ */ t.jsx(g, { fixedWidth: !0, icon: i ? n : o || r ? d : n }), children: i ? e : o || (c ? a : r ? l : m ? p : s) });
});
G.displayName = "Messenger";
export {
  G as default
};
//# sourceMappingURL=Messenger.js.map
